/*
creditcard-date

usage:
test a date against to be valid for a creditCard transaction

return:
 Boolean

*/
function isStringOrNumber(t) {
	return typeof t === 'string' || typeof t === 'number';
}

function containsOnlyDigits(t) {
	if (!isStringOrNumber(t)) return false;
	const str = typeof t === 'string' ? t : t.toString();
	const nums = new RegExp(/^\+?[0-9]+$/);
	return nums.test(str);
}

function isValidMonthNumber(t) {
	if (!isStringOrNumber(t)) return false;
	const str = typeof t === 'string' ? t : t.toString();
	const num = typeof t === 'number' ? t : parseInt(t, 10);
	return Boolean(containsOnlyDigits(str) && num > 0 && num < 13);
}

function isYearOf2K(t) {
	if (!isStringOrNumber(t)) return false;
	const str = typeof t === 'string' ? t : t.toString();
	const num = typeof t === 'number' ? t : parseInt(t, 10);
	return Boolean(containsOnlyDigits(str) && num >= 2000 && num <= 3000);
}

function isLaterThanThisMonth(m, y) {
	const valMonth = isValidMonthNumber(m) ? parseInt(m, 10) : null;
	const valYear = isYearOf2K(y) ? parseInt(y, 10) : null;
	if (!valMonth || !valYear) {
		// the errormessage will not display when it is used together with yup- and formik,
		// probably since the try-catch in these libraries hides the message
		// Thus the 'console.error' is added explicitly.
		// eslint-disable-next-line
		console.error(
			'creditcard-date:isLaterThanThisMonth: not valid arguments for month and year',
			m,
			y
		);
		throw new Error('creditcard-date:isLaterThanThisMonth: not valid arguments for month and year', m, y);
	}
	let valid = false;
	const currentYear = new Date().getFullYear();
	const currentMonth = new Date().getMonth();
	if (valMonth && valYear) {
		if (valYear < currentYear) {
			valid = false;
		} else if (valYear === currentYear) {
			/* if the input year is this year, then the month must be minimum this month
			important:
			The months go from 0 - 11 and input might be 1-12 */
			valid = Boolean(valMonth > currentMonth);
		} else {
			valid = true;
		}
	}
	return valid;
}

export { isValidMonthNumber, isYearOf2K, isLaterThanThisMonth };
